import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import './Testimonials.css';

const testimonialsData = [
    {
        stars: 5,
        text: "Incredibly professional and efficient. My TV was mounted perfectly, and they left the area spotless. Highly recommend for any handyman needs in Northridge!",
        author: "Jessica L.",
        source: "Thumbtack",
    },
    {
        stars: 5,
        text: "Assembled a whole bedroom set from IKEA in just a few hours. What would have taken me days, they did perfectly. Worth every penny.",
        author: "Michael B.",
        source: "Yelp",
    },
    {
        stars: 5,
        text: "Needed a light fixture replaced and a few outlets updated. The job was done quickly, safely, and at a very fair price. Will definitely call again.",
        author: "Sarah K.",
        source: "Thumbtack",
    },
    {
        stars: 5,
        text: "Fixed a persistent leak under my kitchen sink that two other plumbers couldn't figure out. Fast, knowledgeable, and very professional.",
        author: "David R.",
        source: "Thumbtack",
    },
    {
        stars: 5,
        text: "They patched a hole in my wall so perfectly you can't even tell it was ever there. The paint match was spot on. Amazing work!",
        author: "Emily C.",
        source: "Yelp",
    },
    {
        stars: 5,
        text: "I had a list of small, random tasks around the house. They tackled everything with a great attitude and skill. My go-to handyman service now.",
        author: "Chris T.",
        source: "Thumbtack",
    }
];

const StarRating = ({ count }) => (
    <div className="star-rating">
        {'★'.repeat(count)}
    </div>
);

const TestimonialCard = ({ testimonial }) => (
    <div className="testimonial-card">
        <StarRating count={testimonial.stars} />
        <p className="testimonial-text">"{testimonial.text}"</p>
        <div className="author-section">
            <span className="author-name">{testimonial.author}</span>
            <span className="testimonial-source">original review from {testimonial.source}</span>
        </div>
    </div>
);

const Testimonials = () => {
    return (
        <section className="testimonials">
            <h2 className="testimonials-title">What Our Customers Say</h2>
            <Swiper
                modules={[Autoplay]}
                spaceBetween={30}
                loop={true}
                freeMode={true}
                grabCursor={true}
                autoplay={{
                    delay: 1,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }}
                speed={5000}
                breakpoints={{
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 'auto',
                        centeredSlides: true,
                    },
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 2,
                        centeredSlides: false,
                    },
                    // when window width is >= 1024px
                    1024: {
                        slidesPerView: 3,
                        centeredSlides: false,
                    },
                }}
                className="testimonials-swiper"
            >
                {testimonialsData.map((testimonial, index) => (
                    <SwiperSlide key={index} className="testimonial-slide">
                        <TestimonialCard testimonial={testimonial} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default Testimonials;
